import { Component, Input, SimpleChanges, forwardRef, ViewChild, ContentChild, TemplateRef } from '@angular/core';
import { IFilterOption, FilterListComponent } from '../filter-list/filter-list.component';
import { ComponentType } from '@angular/cdk/portal';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { AdRichDropdownComponent } from '../ad-rich-dropdown.component';

export const FilterListDropdown_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FilterDropdownComponent),
  multi: true
}

@Component({
  selector: 'filter-dropdown',
  templateUrl: './filter-dropdown.component.html',
  styleUrls: ['./filter-dropdown.component.scss'],
  providers: [FilterListDropdown_VALUE_ACCESSOR]
})
export class FilterDropdownComponent implements ControlValueAccessor {
  @Input() options: IFilterOption[] = [];

  @Input() placeholder: string;

  @Input() style: any;

  @Input() panelStyle: any;

  @Input() itemSize: number;

  @Input() listStyle: any;

  @Input() customFilter: TemplateRef<any>;

  @ViewChild('dropdown', { static: true }) control: AdRichDropdownComponent;

  filterListComponent: ComponentType<FilterListComponent> = FilterListComponent;
  filterListInput: any;

  ngOnChanges(changes: SimpleChanges) {
    if (['options', 'panelStyle', 'customFilter', 'listStyle', 'itemSize'].findIndex(it => it in changes) >= 0) {
      this.refreshFilterListInput();
    }
  }

  refreshFilterListInput() {
    this.filterListInput = {
      options: this.options,
      panelStyle: this.panelStyle,
      customFilter: this.customFilter,
      itemSize: this.itemSize,
      listStyle: this.listStyle,
    };
  }


  writeValue(obj: any): void {
    this.control.writeValue(obj);
  }
  registerOnChange(fn: any): void {
    this.control.registerOnChange(fn);
  }
  registerOnTouched(fn: any): void {
    this.control.registerOnTouched(fn);
  }
  setDisabledState?(isDisabled: boolean): void {
    this.control.setDisabledState(isDisabled);
  }
}